var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4621_18417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47751 3.79074H4.73877C4.21534 3.79074 3.79102 4.21506 3.79102 4.73849V9.47724C3.79102 10.0007 4.21534 10.425 4.73877 10.425H9.47751C10.0009 10.425 10.4253 10.0007 10.4253 9.47724V4.73849C10.4253 4.21506 10.0009 3.79074 9.47751 3.79074Z",
    stroke: "#3AB1F6",
    strokeWidth: 0.947749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89599 7.58173C1.37473 7.58173 0.948242 7.15524 0.948242 6.63398V1.89523C0.948242 1.37397 1.37473 0.947479 1.89599 0.947479H6.63474C7.156 0.947479 7.58249 1.37397 7.58249 1.89523",
    stroke: "#3AB1F6",
    strokeWidth: 0.947749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4621_18417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.373,
    height: 11.373,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.e5f15e48267b8e9a1b92de5039c2aa87.svg";
export { ForwardRef as ReactComponent };